<template>
    <o-modal name="products">
        <template slot="content" slot-scope="props">
            <products-list
                :day-in-week="props.payload.dayInWeek"
                :address-id="props.payload.addressId"
                :warehouse-id="props.payload.warehouseId"
                :external-supplier="props.payload.externalSupplier"
            ></products-list>
        </template>
    </o-modal>
</template>

<script>
import ProductsList from './ProductsList.vue'
export default {
    components: {
        ProductsList
    }
}
</script>
